import React from 'react';
import classNames from "classnames/bind";
import {Input} from "neatui";
import Styles from './PlagiarizeLink.scss';

const cx = classNames.bind(Styles);

class PlagiarizeLinkItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plagiarizeValue: '',
      originValue: '',
      error: null,
    };
  }

  isUrl = str => {
    // eslint-disable-next-line max-len
    const v = new RegExp('^(?!mailto:)(?:(?:http|https)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i');
    return v.test(str);
  };

  componentWillReceiveProps(nextProps) {
    const plagiarizeUrl = this.isUrl(nextProps.data.plagiarizeValue);
    const originUrl = this.isUrl(nextProps.data.originValue);
    if (!plagiarizeUrl || !originUrl) {
      if (!plagiarizeUrl) {
        this.setState({
          error: nextProps.data.plagiarizeValue ? '链接格式错误' : '请输举报链接',
        });
        return;
      }
      if (!originUrl) {
        this.setState({
          error: nextProps.data.originValue ? '链接格式错误' : '请输原创链接',
        });
      }
    } else {
      this.setState({
        error: null,
      });
    }
  }

  handlePlagiarizeChange = events => {
    const { target: { value } } = events;
    this.setState({
      plagiarizeValue: value,
    });
    const { onChange, id } = this.props;
    const { originValue, error } = this.state;
    onChange({ originValue, plagiarizeValue: value, id });
    if (error && originValue && value) {
      this.setState({
        error: null,
      });
    }
  };

  handleOriginChange = events => {
    const { target: { value } } = events;
    this.setState({
      originValue: value,
    });
    const { onChange, id } = this.props;
    const { plagiarizeValue, error } = this.state;
    onChange({ originValue: value, plagiarizeValue, id });
    if (error && plagiarizeValue && value) {
      this.setState({
        error: null,
      });
    }
  };

  renderLinkItem = () => {
    const { plagiarizeValue, originValue, error } = this.state;
    const { id, onDeleteCurrent, hideDel } = this.props;
    return (
      <div className={cx('plagiarize-link-item')}>
        <div>
          <span>举报链接</span>
          <div>
            <Input onChange={this.handlePlagiarizeChange} value={plagiarizeValue} placeholder="请输入" />
          </div>
        </div>
        <div>
          <span>原创链接</span>
          <div>
            <Input onChange={this.handleOriginChange} value={originValue} placeholder="请输入" />
          </div>
        </div>
        {!hideDel ? (
          <span className={cx('plagiarize-link-del')} onClick={() =>onDeleteCurrent(id)}>删除</span>
        ) : null}
        {plagiarizeValue && originValue && !error ? (
          <span className={cx('plagiarize-link-success', 'ne-icon', 'ne-icon-ok-o')} />
        ) : null}
        {error ? (<span className={cx('error')}>{error}</span>) : null}
      </div>
    )
  };

  render() {
    return this.renderLinkItem();
  }
}

export default PlagiarizeLinkItem;
